import { CloudDownload, Folder } from '@mui/icons-material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import VerifiedIcon from '@mui/icons-material/Verified'
import { Badge, Box, Button, Divider, FormHelperText, Grid, IconButton } from '@mui/material'
import Typography from '@mui/material/Typography'
import dayjs from 'dayjs'
import { head, isEmpty } from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import DatePickerInlineLabel from '../../../components/CustomInputs/DatePicker/DatePickerInlineLabel'
import SelectField from '../../../components/CustomInputs/Select/SelectField'
import SelectFieldCheckbox from '../../../components/CustomInputs/Select/SelectFieldCheckbox'
import RFQListDialog from '../../../components/Dialog/RFQListDialog'
import SaveAndCloseDialog from '../../../components/Dialog/SaveAndCloseDialog'
import SaveDialog from '../../../components/Dialog/SaveDialog'
import UploadDialog from '../../../components/Dialog/UploadDialog'
import { validateAttachments } from '../../../components/Dialog/attachmentValidation'
import UploadDialogInner from '../../../components/Dialog/UploadDialogInner'
import TextBox from '../../../components/Inputs/TextBox'
import { Emergency } from '../../../components/SelectBox'
import { data as rfqTypeData } from '../../../components/SelectBox/RFQType'
import VendorCodeSelecboxGrid from '../../../components/SelectBox/VendorCodeSelecboxGrid'
import TextForm from '../../../components/TextBox/TextForm'
import { showErrorToast, showSuccessToast, showWarningToast } from '../../../constToast/constToast'
import { useGetBIDsByIdQuery, usePostBIDsMutation } from '../../../store/api/bidsApi'
import { useGetBusinessByUserQuery } from '../../../store/api/businessApi'
import { useGetRFQByIdQuery } from '../../../store/api/rfqsApi'
import { useGetCurrentUserInfoQuery } from '../../../store/api/userApi'
import { useGetVendorAllQuery, useGetVendorCardQuery } from '../../../store/api/vendorApi'
import { updateRFQMainIdSlice, updatebidsRowsDetailsSlice } from '../../../store/slice/bidsSlice'
import { hideSaveAndCloseDialog, hideSaveDialog, hideSubmitDialog, toggleUploadDialog, toggleUploadDialogInner } from '../../../store/slice/dialogSlice'
import { updateAttachmentCount } from '../../../store/slice/mainToCardSlice'
import BIDsCardList from './bidsComponent/BIDsCardList'
import { vendorCodeColumns } from './columns'
import {
  BIDDING_TYPE_AUTOMATIC,
  BIDDING_TYPE_MANUAL,
  DATE_FORMAT,
  DISCOUNT_TYPE_AMOUNT,
  DISCOUNT_TYPE_NA,
  DISCOUNT_TYPE_PERCENT,
  SAVE_AND_CLOSE_DIALOG_TYPE,
  SAVE_DIALOG_TYPE,
  USER_TYPE_COMPANY,
  USER_TYPE_VENDOR,
  approvalStatusList,
  discountTypeList,
  statusList,
} from './constants'
import { calculationByMainDiscountType, preCalcRowsDetails } from './helper'
import { bidsCardDefaultValues } from './initialValues'
import SubmitDialog from '../../../components/Dialog/SubmitDialog'
import { useTranslation } from 'react-i18next'
import AcceptRfqDialog from '../../../components/Dialog/AcceptRfqDialog'

const BIDsCard = () => {
  const { dataId } = useParams()
  const isNewRecord = !parseInt(dataId)
  const { data: currentUserDate } = useGetCurrentUserInfoQuery()
  const isVendor = currentUserDate?.data?.userType === USER_TYPE_VENDOR
  const isEdit = parseInt(dataId)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isDisabled = true

  const { t } = useTranslation('bid')

  const bidsMainFilterSlice = useSelector((state) => state.bidsSlice.bidsMainFilterSlice)

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
    getValues,
    setValue,
  } = useForm({
    defaultValues: bidsCardDefaultValues,
  })

  // useEffect(() => {
  //   dispatch(updateRFQMainIdSlice(0))
  // }, [])

  const watchVendorCode = watch('vendorCode')
  const [refresh, setRefresh] = useState(false)
  const rfqMainIdSlice = useSelector((state) => state.bidsSlice.rfqMainIdSlice)
  const vendorCodeReference = useSelector((state) => state.bidsSlice.vendorCodeReference)
  ////
  const { refetch: refetchRfq, isFetching: isFetchingRFQ } = useGetRFQByIdQuery(rfqMainIdSlice)
  const { data: bidsData, isLoading: bidsDataLoading, refetch: bidsDataRefetch } = useGetBIDsByIdQuery(dataId)
  const bidsRowsDetailsSlice = useSelector((state) => state.bidsSlice.bidsRowsDetailsSlice)
  const { data: businessByUserData } = useGetBusinessByUserQuery()

  const { data: vendor } = useGetVendorAllQuery()
  const vendorData = vendor?.data ?? []
  const [vendorDataId, setVendorDataId] = useState({})

  const [rfqData, setRfqData] = useState({})
  const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked)

  const { refetch: vendorDataIdRefetch } = useGetVendorCardQuery(
    vendorData?.find((item) => item?.vendorCode == watchVendorCode)?.vendorId || 0
  )

  const getVendor = async () => {
    const { data } = await vendorDataIdRefetch()
    setVendorDataId(data)
  }
  const [attachmentRFQ, setAttachmentRFQ] = useState([])
  const getRfq = async () => {
    const { data } = await refetchRfq()
    setRfqData(data)
    setAttachmentRFQ(data?.data?.attachments)
  }

  useEffect(() => {
    if (rfqMainIdSlice) {
      getRfq()
    }
  }, [rfqMainIdSlice])

  useEffect(() => {
    getVendor()
  }, [watchVendorCode, vendorData])

  const [attachments, setAttachments] = useState([])
  const [commercialAttachments, setCommercialAttachments] = useState([])


  useEffect(() => {
    // dispatch(updateRFQMainIdSlice(null))

    if (isNewRecord) {
      reset({
        ...bidsCardDefaultValues,
        enteredBy: currentUserDate?.data?.fullName,
        businessUnitId: rfqData?.data?.businessUnit?.businessUnitId ?? bidsData?.data?.businessUnitId,
        desiredDeliveryDate: null,
        requiredOnSiteDate: null,
        rfqDate: null,
      })

      dispatch(updatebidsRowsDetailsSlice([]))
      dispatch(updateAttachmentCount())
      setAttachments([])
      setCommercialAttachments([])
      setVendorDataId({})
      return
    }

    bidsDataRefetch()
    setRefresh((prevState) => !prevState)
    dispatch(updatebidsRowsDetailsSlice(preCalcRowsDetails(bidsData?.data?.details, dataId)))
  }, [refreshClicked])

  useEffect(() => {
    const type0AttachmentsLength = attachments.filter((item) => item.type === 0).length
    dispatch(updateAttachmentCount(type0AttachmentsLength))
  }, [attachments, commercialAttachments])

  useEffect(() => {
    reset({
      ...getValues(),
      businessUnitId: rfqData?.data?.businessUnit?.businessUnitId ?? bidsData?.data?.businessUnitId,
      rfqType: !parseInt(dataId)
        ? rfqData?.data?.rfqType
          ? [rfqData?.data?.rfqType]
          : null
        : [bidsData?.data?.rfqMain?.rfqType],
      rfqNo: !parseInt(dataId)
        ? rfqData?.data?.rfqNo
          ? [rfqData?.data?.rfqNo]
          : null
        : bidsData?.data?.rfqMain?.rfqNo,
      rfqDeadline: !parseInt(dataId) ? rfqData?.data?.rfqDeadline : bidsData?.data?.rfqMain?.rfqDeadline,

      enteredBy: !parseInt(dataId) ? currentUserDate?.data?.fullName : bidsData?.data?.enteredBy,
      bidNo: !parseInt(dataId) ? '' : bidsData?.data?.bidNo,
      rfqMainId: !parseInt(dataId) ? rfqData?.data?.id : bidsData?.data?.rfqMainId,
      comparisonNo: !parseInt(dataId) ? '' : bidsData?.data?.comparisonNo,
      orderNo: !parseInt(dataId) ? '' : bidsData?.data?.orderNo,
      attachments: isNewRecord ? null : bidsData?.data?.attachments,
      entryDate: !parseInt(dataId) ? dayjs().format(DATE_FORMAT) : dayjs(bidsData?.data?.entryDate).format(DATE_FORMAT),
      desiredDeliveryDate: !parseInt(dataId)
        ? rfqData?.data?.desiredDeliveryDate
        : bidsData?.data?.rfqMain?.desiredDeliveryDate,
      requiredOnSiteDate: !parseInt(dataId)
        ? rfqData?.data?.requiredOnSiteDate
        : bidsData?.data?.rfqMain?.requiredOnSiteDate,
      rfqDate: !parseInt(dataId) ? rfqData?.data?.rfqDate : bidsData?.data?.rfqMain?.rfqDate,
      operatorComment: !parseInt(dataId) ? rfqData?.data?.operatorComment : bidsData?.data?.operatorComment,
      comment: !parseInt(dataId) ? rfqData?.data?.comment : bidsData?.data?.rfqMain?.rfqComment,
      placeOfDelivery: !parseInt(dataId) ? rfqData?.data?.placeOfDelivery : bidsData?.data?.rfqMain?.placeOfDelivery,
      sentDate: !parseInt(dataId)
        ? dayjs(rfqData?.data?.sentDate).format(DATE_FORMAT)
        : dayjs(bidsData?.data?.rfqMain?.sentDate).format(DATE_FORMAT),
      emergency: !parseInt(dataId)
        ? rfqData?.data?.emergency
          ? [rfqData?.data?.emergency]
          : []
        : bidsData?.data?.rfqMain?.emergency
          ? [bidsData?.data?.rfqMain?.emergency]
          : [],
      currencyCode: isNewRecord ? 'AZN' : bidsData?.data?.currencyCode,

      discountType: bidsData?.data?.discountType,
      discountValues: rfqData?.data?.discountValues ?? bidsData?.data?.discountValues,
      vendorCode: Boolean(vendorCodeReference)
        ? vendorCodeReference
        : isEdit
          ? bidsData?.data?.vendorCode
          : isVendor
            ? vendorData?.find((item) => item?.vendorId === currentUserDate?.data?.vendorId)?.vendorCode
            : isNewRecord
              ? getValues('vendorCode')
              : '',
      approveStageMainId: !parseInt(dataId) ? rfqData?.data?.approveStageMainId ?? 0 : 0,
      status: isNewRecord ? 0 : bidsData?.data?.status ?? 0,
      approvalStatus: isNewRecord ? rfqData?.data?.approvalStatus ?? 0 : bidsData?.data?.approveStatus ?? 0,
      buyer: rfqData?.data?.buyer || '',
    })
  }, [bidsData, rfqData, vendor, refresh, rfqMainIdSlice])

  useEffect(() => {
    reset({
      ...getValues(),
      deliveryTerms: bidsData?.data?.deliveryTerms,
      deliveryTime: bidsData?.data?.deliveryTime,
      paymentTerms: bidsData?.data?.paymentTerms,
      expectedCost: bidsData?.data?.expectedCost,
    })
  }, [bidsData, refresh])

  useEffect(() => {
    reset({
      ...getValues(),
      commercialAttachments: isNewRecord ? commercialAttachments : bidsData?.data?.commercialAttachments,
    })
  }, [commercialAttachments])

  useEffect(() => {
    reset({
      ...getValues(),
      deliveryTerms: isEdit ? bidsData?.data?.deliveryTerms : null, //vendorDataId?.data?.header?.deliveryTerms ?? '',
      paymentTerms: isEdit ? bidsData?.data?.paymentTerms : vendorDataId?.data?.header?.paymentTerms ?? '',

      vendorName: vendorDataId?.data?.header?.vendorName ?? '',
      address: vendorDataId?.data?.header?.address1 ?? '',
      contact: vendorDataId?.data?.header?.contactPerson ?? '',
      email: vendorDataId?.data?.header?.emailAddress ?? '',
      country: vendorDataId?.data?.header?.country ?? '',
      phone: vendorDataId?.data?.header?.phone_Mobile ?? '',
      taxId: vendorDataId?.data?.header?.taxId ?? '',
      taxCode: vendorDataId?.data?.taxDatas?.find((item) => item?.taxId === vendorDataId?.data?.header?.tax)?.taxCode,
    })
  }, [vendorDataId])

  useEffect(() => {
    if (!parseInt(dataId)) {
      dispatch(updatebidsRowsDetailsSlice(preCalcRowsDetails(rfqData?.data?.details, dataId)))
    }
  }, [dispatch, rfqData])

  useEffect(() => {
    if (parseInt(dataId) && bidsData?.data?.details?.length > 0) {
      dispatch(updatebidsRowsDetailsSlice(preCalcRowsDetails(bidsData?.data?.details, dataId)))
    }
  }, [dispatch, bidsData])

  const [postBIDs] = usePostBIDsMutation()

  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [totalDiscountedAmount, setTotalDiscountedAmount] = useState(0)
  const onSubmit = async (data, type) => {
    if (Number(totalDiscountedAmount) <= 0) {
      showWarningToast('Total Amount must be greater than 0')
      return
    }

    // fileLink-i olmayan attachment save-e getmemelidir
    if (!validateAttachments([...(attachments || []), ...(commercialAttachments || [])])) {
      return
    }

    setLoadingSubmit(true)
    const bidDetailsFormating = bidsRowsDetailsSlice.map((item) => ({
      ...item,
      condition: item?.condition?.conditionValue ?? 0,
    }))

    const values = {
      ...data,
      bidMainId: isNewRecord ? 0 : bidsData?.data?.bidMainId,
      bidNo: data?.bidNo ?? '',
      businessUnitId: data.businessUnitId,
      rfqMainId: bidsData?.data?.rfqMainId ? bidsData?.data?.rfqMainId : rfqData?.data?.id,
      operatorComment: data.operatorComment ?? '',
      comment: data.comment ?? '',
      userId: currentUserDate?.data?.userId,
      currencyCode: data?.currencyCode ?? '',
      discountType: isNewRecord ? data.discountType : head(data.discountType),
      vendorCode: Array.isArray(data?.vendorCode) ? head(data.vendorCode) : data?.vendorCode,
      attachments: attachments,
      commercialAttachments: commercialAttachments,
      bidDetails: bidDetailsFormating,
      expectedCost: data?.expectedCost || 0,
      // status: data?.status == 0 ? 6 : data?.status
    }

    const isPuomValid = values.bidDetails.every((item) => item?.puom)
    const isConversionRateValid = values.bidDetails.every((item) => item?.conversionRate)

    const detailsDiscountTypeIsSet = values.bidDetails.filter((item) => item?.discountType)
    const isDiscountValueValid = isEmpty(detailsDiscountTypeIsSet)
      ? true
      : detailsDiscountTypeIsSet.every((item) => item?.discountValue)

    if (!isDiscountValueValid) {
      setLoadingSubmit(false)
      showErrorToast('Discount value is not valid')
      return
    }

    if (!isPuomValid) {
      setLoadingSubmit(false)
      showErrorToast('PUOM field is required')
      return
    }

    if (!isConversionRateValid) {
      setLoadingSubmit(false)
      showErrorToast('Conversion field is not valid')
      return
    }

    try {
      const bidsPostQuery = await postBIDs(values)
      if (bidsPostQuery?.data?.statusCode === 200) {
        if (type === SAVE_DIALOG_TYPE) {
          reset({
            ...getValues(),
            bidNo: bidsPostQuery?.data?.data?.bidNo,
          })
          dispatch(hideSaveDialog())
          dispatch(hideSubmitDialog())
          navigate(`/bids/${bidsPostQuery?.data?.data?.id}`)
          showSuccessToast(`${bidsPostQuery?.data?.data?.bidNo} Successfully saved`)
          setLoadingSubmit(false)
          return
        }

        if (type === SAVE_AND_CLOSE_DIALOG_TYPE) {
          dispatch(hideSaveAndCloseDialog())
          dispatch(updatebidsRowsDetailsSlice([]))
          navigate('/bids')
          showSuccessToast(`${bidsPostQuery?.data?.data?.bidNo} Successfully saved`)
          setLoadingSubmit(false)
        }
      }
    } catch (error) {
      console.error('An error occurred:', error)
      setLoadingSubmit(false)
    }
  }

  //Responsive
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(!open)
  }

  let xlGrid1 = open ? 8 : 11.5
  let xlGrid2 = open ? 4 : 0.5
  let lgGrid1 = open ? 8 : 11
  let lgGrid2 = open ? 4 : 1
  let mdGrid1 = open ? 12 : 12
  let mdGrid2 = open ? 12 : 12
  let smGrid1 = open ? 12 : 12
  let smGrid2 = open ? 12 : 12
  let xsGrid1 = open ? 12 : 12
  let xsGrid2 = open ? 12 : 12
  const RFQData = bidsData?.data?.rfqMain || rfqData?.data
  let formIsDisabled = isNewRecord
    ? false
    : bidsData?.data?.status == 1
      ? true
      : RFQData?.biddingType == BIDDING_TYPE_AUTOMATIC && moment(RFQData?.rfqDeadline).isSameOrBefore()

  if (window.location.href.includes('fromVendor') && RFQData?.biddingType == BIDDING_TYPE_MANUAL) {
    formIsDisabled = true
  }

  useEffect(() => {
    return () => {
      // dispatch(updateRFQMainIdSlice(null))
      setRfqData(null)
    }
  }, [])

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container>
          <Grid
            item
            sx={{
              minHeight: '300px',
            }}
            xs={xsGrid1}
            sm={smGrid1}
            md={mdGrid1}
            lg={lgGrid1}
            xl={xlGrid1}
          >
            <Grid container display="flex" spacing={2}>
              <Grid item xs={2}>
                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name={'businessUnitId'}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <>
                        <SelectField
                          id={'businessUnitId'}
                          label={t('business_unit')}
                          options={businessByUserData?.data || []}
                          optionName={'businessUnitName'}
                          onBlur={onBlur}
                          value={value}
                          disabled={isDisabled}
                          onChange={onChange}
                        />
                      </>
                    )}
                  />
                </Box>

                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name={'rfqType'}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <SelectFieldCheckbox
                          id={'value'}
                          label={t('rfq_type')}
                          options={rfqTypeData}
                          optionName={'label'}
                          onBlur={onBlur}
                          value={value?.map((itemValue) => rfqTypeData.find((item) => item.value === itemValue)) || []}
                          disabled={isDisabled}
                          onChange={onChange}
                        />
                      </div>
                    )}
                  />
                </Box>

                <Box sx={{ pb: 2 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Controller
                      control={control}
                      name="rfqNo"
                      render={({ field: { onChange, onBlur, value } }) => (
                        <TextBox
                          label={t('rfq_no')}
                          value={value}
                          onChange={onChange}
                          onBlur={onBlur}
                          disabled={isDisabled}
                        />
                      )}
                    />

                    {/* <IconButton
                      disabled={!head(watch('rfqNo'))}
                      onClick={() => {
                        if (currentUserDate?.data?.userType === USER_TYPE_VENDOR) {
                          const rfqMainId = !parseInt(dataId) ? rfqData?.data?.id : bidsData?.data?.rfqMainId
                          dispatch(updateRFQMainIdSlice(rfqMainId))
                          navigate(`/vendors/${currentUserDate?.data?.vendorId}`)
                        }

                        if (currentUserDate?.data?.userType === USER_TYPE_COMPANY) {
                          const rfqMainId = parseInt(dataId) ? bidsData?.data?.rfqMainId : RFQData?.id
                          if (!rfqMainId) {
                            return
                          }

                          navigate(`/rfqs/${rfqMainId}`)
                        }
                      }}
                    >
                      <Folder
                        sx={
                          !head(watch('rfqNo'))
                            ? { color: '#ccc', width: '18px', height: '18px' }
                            : { color: '#3498db', width: '18px', height: '18px' }
                        }
                      />
                    </IconButton> */}


                    <Box>
                      <Badge badgeContent={attachmentRFQ?.filter(x => x.type == 0)?.length} color="error">
                        <IconButton onClick={() => dispatch(toggleUploadDialogInner())}>
                          <CloudDownload sx={{ color: '#3498db' }} />
                        </IconButton>
                      </Badge>
                      <UploadDialogInner
                        module={'Rfqs'}
                        value={attachmentRFQ || []}
                        setValue={setAttachmentRFQ}
                        initialData={attachmentRFQ || []}
                        onlyView={true}
                      />

                    </Box>
                  </div>
                </Box>

                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name="rfqDeadline"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <DatePickerInlineLabel
                        hasHour
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        label={t('rfq_deadline')}
                        disabled={isDisabled}
                        error={Boolean(errors['rfqDeadline'])}
                        helperText={errors['rfqDeadline'] ? errors['rfqDeadline'].message : ''}
                      />
                    )}
                  />
                </Box>
              </Grid>

              <Grid item xs={2}>
                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name="enteredBy"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextBox
                        label={t('entered_by')}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        disabled={isDisabled}
                      />
                    )}
                  />
                </Box>
                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name="bidNo"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextBox
                        label={t('bid_no')}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        disabled={isDisabled}
                      />
                    )}
                  />
                </Box>

                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name="comparisonNo"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextBox
                        label={t('comparison_no')}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        disabled={isDisabled}
                      />
                    )}
                  />
                </Box>

                <Box sx={{ pb: 2 }}>
                  <TextForm label={t('buyer')} dynamicField='buyer'
                    control={control} errors={errors} disabled={true} />
                </Box>

                {/* <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name="orderNo"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextBox
                        label={'Order No'}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        disabled={isDisabled}
                      />
                    )}
                  />
                </Box> */}
              </Grid>

              <Grid item xs={2}>
                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name="entryDate"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <DatePickerInlineLabel
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        label={t('entry_date')}
                        disabled={isDisabled}
                        error={Boolean(errors['entryDate'])}
                        helperText={errors['entryDate'] ? errors['entryDate'].message : ''}
                      />
                    )}
                  />
                </Box>

                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name="desiredDeliveryDate"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <DatePickerInlineLabel
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        label={t('desired_delivery_date')}
                        disabled={isDisabled}
                        error={Boolean(errors['entryDate'])}
                        helperText={errors['desiredDeliveryDate'] ? errors['desiredDeliveryDate'].message : ''}
                      />
                    )}
                  />
                </Box>

                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name={'requiredOnSiteDate'}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <DatePickerInlineLabel
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        label={t('required_on_site_date')}
                        disabled={isDisabled}
                        error={Boolean(errors['requiredOnSiteDate'])}
                        helperText={errors['requiredOnSiteDate'] ? errors['requiredOnSiteDate'].message : ''}
                      />
                    )}
                  />
                </Box>

                <Box sx={{ pb: 2 }}>
                  <Controller
                    control={control}
                    name="rfqDate"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <DatePickerInlineLabel
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        label={t('rfq_date')}
                        disabled={isDisabled}
                        error={Boolean(errors['rfqDate'])}
                        helperText={errors['rfqDate'] ? errors['rfqDate'].message : ''}
                      />
                    )}
                  />
                </Box>
              </Grid>
              <Grid item xs={3}>
                {/*   <Box sx={{ mb: 2 }}>
                  <TextForm
                    control={control}
                    dynamicField="operatorComment"
                    label={t('comment')}
                    multiline
                    disabled={formIsDisabled}
                    rows={1}
                  />
                </Box> */}

                <Box sx={{ mb: 2 }}>
                  <TextForm
                    control={control}
                    dynamicField="comment"
                    label="RFQ Comment"
                    multiline
                    disabled={true}
                    rows={4}
                  />
                </Box>


                <Box sx={{ mb: 2 }}>
                  <TextForm
                    control={control}
                    dynamicField="placeOfDelivery"
                    label={t('place_of_delivery')}
                    multiline
                    rows={1}
                    disabled={isDisabled}
                  />
                </Box>

                <Grid container display="flex" justifyContent="space-between">
                  {(parseInt(dataId) && bidsData?.data?.rfqMain?.biddingType === BIDDING_TYPE_AUTOMATIC) ||
                    (!parseInt(dataId) && rfqData?.data?.biddingType === BIDDING_TYPE_AUTOMATIC) ? (
                    <Grid item xs={5}>
                      <Box sx={{ pb: 2 }}>
                        <Controller
                          control={control}
                          name="sentDate"
                          render={({ field: { onChange, onBlur, value } }) => (
                            <DatePickerInlineLabel
                              value={value}
                              onChange={onChange}
                              onBlur={onBlur}
                              label={t('sent_date')}
                              error={Boolean(errors['sentDate'])}
                              helperText={errors['sentDate'] ? errors['sentDate'].message : ''}
                              disabled={isDisabled}
                            />
                          )}
                        />
                      </Box>
                    </Grid>
                  ) : null}
                </Grid>
                <Grid item xs={5}>
                  <Box>
                    <Controller
                      control={control}
                      name={'emergency'}
                      render={({ field: { onChange, onBlur, value } }) => (
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                          }}
                        >
                          <Emergency
                            label={t("priority")}
                            error={errors?.emergency}
                            hasAll={false}
                            value={value}
                            setValue={onChange}
                            isDisabled={true}
                          />
                        </div>
                      )}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={9}>
                <Divider className="theme-divider" textAlign="left">
                  <Typography sx={{ fontWeight: 'bold' }} variant="h5" component="span">
                    Terms.
                  </Typography>
                </Divider>

                <Grid container display="flex" justifyContent="space-between" spacing={2} mt={1}>
                  <Grid item xs={3}>
                    <Box sx={{ pb: 2 }}>
                      <Controller
                        control={control}
                        name="deliveryTerms"
                        rules={{
                          required: {
                            value: true,
                            message: 'This field is required',
                          },
                        }}
                        render={({ field: { onChange, onBlur, value } }) => (
                          <>
                            <SelectField
                              id={'deliveryTermCode'}
                              label={t('delivery_terms')}
                              options={vendorDataId?.data?.deliveryTerms || []}
                              optionName={'deliveryTermName'}
                              onBlur={onBlur}
                              value={value}
                              disabled={formIsDisabled}
                              onChange={onChange}
                              error={Boolean(errors['deliveryTerms'])}
                            />
                            {errors['deliveryTerms'] && (
                              <FormHelperText sx={{ color: '#d32f2f' }}>
                                {errors['deliveryTerms'].message}
                              </FormHelperText>
                            )}
                          </>
                        )}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box sx={{ pb: 2 }}>
                      <Controller
                        control={control}
                        name="deliveryTime"
                        rules={{
                          required: {
                            value: true,
                            message: 'This field is required',
                          },
                        }}
                        render={({ field: { onChange, onBlur, value } }) => (
                          <>
                            <TextBox
                              label={t('delivery_time')}
                              value={value}
                              onChange={onChange}
                              onBlur={onBlur}
                              disabled={formIsDisabled}
                              error={Boolean(errors['deliveryTime'])}
                            />
                            {errors['deliveryTime'] && (
                              <FormHelperText sx={{ color: '#d32f2f' }}>
                                {errors['deliveryTime'].message}
                              </FormHelperText>
                            )}
                          </>
                        )}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box sx={{ pb: 2 }}>
                      <Controller
                        control={control}
                        name={'paymentTerms'}
                        rules={{
                          required: {
                            value: true,
                            message: 'This field is required',
                          },
                        }}
                        render={({ field: { onChange, onBlur, value } }) => (
                          <>
                            <SelectField
                              id={'analysisCode'}
                              label={t('payment_terms')}
                              options={vendorDataId?.data?.paymentTerms || []}
                              optionName={'analysisName'}
                              onBlur={onBlur}
                              value={value}
                              disabled={formIsDisabled}
                              onChange={onChange}
                              error={Boolean(errors['paymentTerms'])}
                            />
                            {errors['paymentTerms'] && (
                              <FormHelperText sx={{ color: '#d32f2f' }}>
                                {errors['paymentTerms'].message}
                              </FormHelperText>
                            )}
                          </>
                        )}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box sx={{ pb: 2 }}>
                      <Controller
                        control={control}
                        name={'currencyCode'}
                        render={({ field: { onChange, onBlur, value } }) => (
                          <SelectField
                            id={'currencyCode'}
                            label={t('currency')}
                            options={
                              vendorDataId?.data?.currencies || [
                                { currencyCode: 'AZN', description: 'Azerbaijan manat' },
                              ]
                            }
                            optionName={'currencyCode'}
                            onBlur={onBlur}
                            value={value}
                            disabled={formIsDisabled} // false
                            onChange={onChange}
                          />
                        )}
                      />
                    </Box>
                  </Grid>


                  <Grid item xs={3}>
                    <Box sx={{ pb: 2 }}>
                      <Controller
                        control={control}
                        name="expectedCost"
                        render={({ field: { onChange, onBlur, value } }) => (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                            }}
                          >
                            <span
                              style={{
                                backgroundColor: '#ccc',
                                borderRadius: '8px',
                                padding: '5px 10px',
                                marginRight: 5,
                                fontSize: '10px',
                                fontWeight: 'bold',
                              }}
                            >
                              {watch('currencyCode')}
                            </span>

                            <div style={{ position: 'relative' }}>
                              <TextBox
                                label={t('additional_cost')}
                                type={'number'}
                                value={value}
                                onChange={(event) => {
                                  if (parseInt(event.target.value) < 0) {
                                    return
                                  }
                                  onChange(event.target.value)
                                }}
                                disabled={formIsDisabled}
                                onBlur={onBlur}
                                error={Boolean(errors['expectedCost'])}
                              />
                            </div>
                          </div>
                        )}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </form>

      <Grid container spacing={3} mt={1}>
        <Grid item xs={12}>
          <BIDsCardList
            totalDiscountedAmount={totalDiscountedAmount}
            setTotalDiscountedAmount={setTotalDiscountedAmount}
            data={bidsRowsDetailsSlice}
            disabled={!parseInt(dataId)}
            formIsDisabled={formIsDisabled}
            businessUnitId={getValues('businessUnitId')}
            businessUnitCode={
              businessByUserData?.data?.find((item) => item?.businessUnitId === getValues('businessUnitId'))
                ?.businessUnitCode
            }
            bidsDataLoading={(isFetchingRFQ || bidsDataLoading)}
          />
        </Grid>
      </Grid>

      <SaveAndCloseDialog
        isDisabled={formIsDisabled}
        handleSaveAndClose={handleSubmit((data) => onSubmit(data, SAVE_AND_CLOSE_DIALOG_TYPE))}
        text="Bid"
      />
      <SaveDialog
        isDisabled={formIsDisabled}
        handleSave={handleSubmit((data) => onSubmit(data, SAVE_DIALOG_TYPE))}
        text="Bid"
      />

      <SubmitDialog
        loadingSubmit={loadingSubmit}
        isDisabled={formIsDisabled}
        handleSubmit={handleSubmit((data) => onSubmit({ ...data, status: data?.status == 0 ? 1 : data?.status }, SAVE_DIALOG_TYPE))}
        text="Bid"
      />


      <UploadDialog
        module={'Bid'}
        value={attachments}
        setValue={setAttachments}
        initialData={bidsData?.data?.attachments}
        onlyView={formIsDisabled}
      />

      {/* <UploadDialogInner
        module={'Bid'}
        value={commercialAttachments}
        setValue={setCommercialAttachments}
        initialData={bidsData?.data?.commercialAttachments}
        onlyView={formIsDisabled}
      /> */}
      <RFQListDialog formIsDisabled={formIsDisabled} />

      <AcceptRfqDialog data={rfqData?.data} />
    </>
  )
}

export default BIDsCard
